import { inject, Injectable } from '@angular/core';
import { ToastComponent } from "../components/toast/toast.component";
import { ModalService } from "../components/modal/modal.service";
import { Toast } from "../models/common.model";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GenericService {
    private modalService = inject(ModalService);
    openToast(toast: Toast,callback?: () => void) {
        if(callback) {
          toast.callback = callback;
        }
        this.modalService.open(ToastComponent, {
          size: {
            width: '80%',
            padding: '1rem'
          },
          data: {
            toast: toast
          }
        })
    }

    getImageRessource(fileName: string): String {
        const resourceUrl = `${environment.APP_URL}/all/user/uploads/`;
        return `${resourceUrl}/${fileName}`
    }
    
}
